import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/download/eighteenPlus.png'


const _hoisted_1 = { style: {"display":"flex","justify-content":"center","align-items":"center","padding":"15px 10px","flex-direction":"column"} }
const _hoisted_2 = { style: {"color":"rgb(32, 33, 36)","fill":"rgb(32, 33, 36)","stop-color":"rgb(32, 33, 36)","font-size":"14px"} }
const _hoisted_3 = { style: {"font-size":"12px","color":"#5f6368","line-height":"20px"} }
const _hoisted_4 = { style: {"display":"flex","justify-content":"center","align-items":"center","padding":"15px 10px 15px 10px","flex-direction":"column"} }
const _hoisted_5 = { style: {"display":"flex","flex-direction":"row"} }
const _hoisted_6 = { style: {"color":"rgb(32, 33, 36)","fill":"rgb(32, 33, 36)","stop-color":"rgb(32, 33, 36)","font-size":"14px"} }
const _hoisted_7 = { style: {"font-size":"12px","color":"#5f6368","line-height":"20px"} }
const _hoisted_8 = { style: {"display":"flex","justify-content":"center","align-items":"center","padding":"15px 10px","flex-direction":"column"} }
const _hoisted_9 = { style: {"font-size":"12px","color":"#5f6368","line-height":"20px"} }

import { ref } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'AppData',
  setup(__props) {

const favValue = ref('4,9')
const downloads = ref('50 mil+')


return (_ctx: any,_cache: any) => {
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_col = _resolveComponent("van-col")!
  const _component_van_row = _resolveComponent("van-row")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_van_row, { style: {"margin-top":"10px","align-items":"center"} }, {
      default: _withCtx(() => [
        _createVNode(_component_van_col, { span: "8" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", null, [
                _createElementVNode("span", _hoisted_2, _toDisplayString(favValue.value), 1),
                _createVNode(_component_van_icon, {
                  name: "star",
                  color: "#000"
                })
              ]),
              _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t('donwload.review')), 1)
            ])
          ]),
          _: 1
        }),
        _cache[1] || (_cache[1] = _createElementVNode("div", { style: {"height":"24px","border-left":"2px solid #e8eaed"} }, null, -1)),
        _createVNode(_component_van_col, { span: "8" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("span", _hoisted_6, _toDisplayString(downloads.value), 1)
              ]),
              _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t('donwload.donwload')), 1)
            ])
          ]),
          _: 1
        }),
        _cache[2] || (_cache[2] = _createElementVNode("div", { style: {"height":"24px","border-left":"2px solid #e8eaed"} }, null, -1)),
        _createVNode(_component_van_col, { span: "7" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_8, [
              _cache[0] || (_cache[0] = _createElementVNode("img", {
                style: {"height":"15px","width":"15px","object-fit":"contain"},
                src: _imports_0
              }, null, -1)),
              _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t('donwload.rated')), 1)
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})